module.exports = __webpack_public_path__ + "img/tools-nft.b2aa3da9.png";